<template>
  <div>
    <span
      :class="{'cs-color-frenchgrey': data.homeworkStatus <=1,'cs-redLabel':data.homeworkStatus == 2, 'cs-color-green': data.homeworkStatus == 3}"
    >
      <i v-if="data.homeworkStatus == 3" class="fa fa-check-circle" aria-hidden="true"></i>
      <i v-if="data.homeworkStatus == 2" class="fa fa-times-circle" aria-hidden="true"></i>
      <i v-if="data.homeworkStatus <=1" class="fa fa-info-circle" aria-hidden="true"></i>
      {{data.homeworkStatusText}}
    </span>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: {
    data: {
      homeworkStatus: 0,
      homeworkStatusText: ""
    }
  },
  data() {
    return {
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/homeworkStatus.vue